import PropTypes from 'prop-types';

export const ScrollerStateProps = PropTypes.shape({
  id: PropTypes.string,
  scrollingElement: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.object,
    PropTypes.string,
  ]),
  moduleClassName: PropTypes.string,
  ready: PropTypes.bool,
  enabled: PropTypes.bool,
  registerModule: PropTypes.func,
  unregisterModule: PropTypes.func,
  enableScroller: PropTypes.func,
  disableScroller: PropTypes.func,
  setScrollerReady: PropTypes.func,
  setScrollerNotReady: PropTypes.func,
});
